









import Vue from 'vue';
import CardGrid from '@/components/card/CardGrid.vue';
import CardStackHeader from '@/components/card/CardStackHeader.vue';
import CardStack from '@/components/card/CardStack.vue';
import SearchFilters from '@/components/search/SearchFilters.vue';
import { Component } from 'vue-property-decorator';
import { Decklist } from '@/types/decklist';
import { MODAL } from '@/store/actions';

@Component({
  components: {
    SearchFilters,
    CardGrid,
    CardStackHeader,
    CardStack,
  },
})
export default class DecklistBuilder extends Vue {
  private isCardStackShown = window.innerWidth > 550;

  get decklist(): Decklist {
    return this.$store.state.decklist.decklist;
  }

  private gotoInspector() {
    this.$store.commit(MODAL.SET_CLOSE_INFO_NORMAL);
    this.$router.push('inspector');
  }

  private toggleList() {
    this.isCardStackShown = !this.isCardStackShown;
  }
}
